/**
 * Общий state модуля spec + cookie-утилиты.
 *
 * Все модули spec (actions, filters, table, modals, columns, export) импортируют `state`
 * как единый источник правды. State мутируется напрямую — это прагматично для
 * императивного legacy-кода; переход на реактивный Alpine-store возможен позже,
 * если появится потребность синхронизировать UI с state автоматически.
 */

export const state = {
    projectId: null,
    selectedFilters: {
        status: [],
        manufacturer: [],
    },
    selectedProducts: [],
    sortableInstances: [],
    deleteProductId: null,
    isAddingProduct: false,
    modalHandlersInitialized: false,
};

export function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
